import {useMemo} from 'react';

import {useOptionalPart, usePart} from '../hooks';
import {usePanelBankConfig} from '../panelBankConfig/hooks';
import {usePanelBankSectionConfig} from '../panelBankSectionConfig/hooks';
import {useOptionalPanels} from '../panels/hooks';
import {useRunSets} from '../runSet/hooks';
import {WholeFromTypeWithRef} from '../types';
import * as SectionTypes from './types';

export function useSection(
  ref: SectionTypes.Ref
): WholeFromTypeWithRef<'section'> {
  const section = usePart(ref);
  const runSets = useRunSets(section.runSetRefs);
  const panels = useOptionalPanels(section.panelsRef);
  const panelBankConfig = usePanelBankConfig(section.panelBankConfigRef);

  const panelBankSectionConfig = usePanelBankSectionConfig(
    section.panelBankSectionConfigRef
  );
  const settings = useOptionalPart(section.panelSettingsRef);
  const customRunColors = usePart(section.customRunColorsRef);
  const customRunNames = usePart(section.customRunNamesRef);
  const workspaceSettings = usePart(section.workspaceSettingsRef);

  return useMemo(
    () => ({
      ...section,
      runSets: runSets,
      panels: panels,
      panelBankConfig: panelBankConfig,
      panelBankSectionConfig: panelBankSectionConfig,
      settings: settings,
      customRunColors: customRunColors,
      customRunNames: customRunNames,
      workspaceSettings: workspaceSettings,
      ref,
    }),
    [
      ref,
      section,
      runSets,
      panels,
      panelBankConfig,
      panelBankSectionConfig,
      settings,
      customRunColors,
      customRunNames,
      workspaceSettings,
    ]
  );
}
